import { Button, EmptyState } from '@/shared/components';

/** Leere Karte: das Objekt hat keine sichtbaren Apartments, oder der Filter blendet alle aus. */
export function GrundkalenderEmpty({
  filtered,
  onShowAll,
}: {
  filtered: boolean;
  onShowAll: () => void;
}) {
  if (!filtered) {
    return <EmptyState icon="Building" title="Für dieses Objekt sind keine Apartments sichtbar." />;
  }
  return (
    <div className="flex flex-col items-center gap-3 p-8 text-center">
      <p className="text-ink-soft text-sm">Kein Apartment gewählt.</p>
      <Button variant="secondary" className="min-h-11" onClick={onShowAll}>
        Alle Apartments zeigen
      </Button>
    </div>
  );
}
